module.exports = {
  templateUrl: 'main/components/appointment-attachments/appointment-attachments.html',
  bindings: {
    appointment: '<',
  },
  controller: class AppointmentAttachments {

    static $inject = [
      '$filter',
      '$window',
    ];

    constructor(
      $filter,
      $window,
    ) {
      this.$filter = $filter;
      this.$window = $window;
    }

    openAttachment(file) {
      if (file.url) {
        this.$window.open(file.url, '_blank');
      } else if (file.id) {
        this.$window.open(this.$filter('apiEndpoint')(`/attachments/${file.id}`), '_blank');
      }
      return null;
    }
  },
};



// WEBPACK FOOTER //
// ./main/components/appointment-attachments/appointment-attachments.js